import { render, staticRenderFns } from "./InputComponent.vue?vue&type=template&id=20c4e3f7&"
import script from "./InputComponent.vue?vue&type=script&lang=ts&"
export * from "./InputComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports